import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import ButtonDownload from '../../Buttons/ButtonDownload/ButtonDownload';

const notSubscriber = (props) => {


  const downloadSongHandler = () => {
    props.downloadSong();
  };

  return (
    <div className='notSubscriber'>
      <div className='to-subscribe-text'>
        <b>שמו לב,</b> אינכם מנויים לשירות המתנה נעימה. <br/>
        <b>כיצד מצטרפים?</b> פשוט לוחצים על הורדה ושיר זה יוגדר כהמתנה נעימה
      </div>

      <div className='charge-text'>
        <span>
          בהורדת שיר ראשון, בגין הצטרפות לשירות המתנה נעימה ללא הגבלה באופן מתמשך תחויב מדי חודש בתשלום קבוע בסך{' '}
          {props.aocDetails.premiumPackagePrice}₪. החיוב יבוצע דרך מנוי {props.selectedSubscriber.cli}.
        </span>
      </div>

      <div className='remark-text'>
        <p>שירים נוספים הינם</p>
        <p>חינם וללא הגבלה.</p>
      </div>

      <div className='btn-holder'>
        <ButtonDownload text='הורדה' onclick={() => downloadSongHandler()} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedSubscriber: state.fundialPage.selectedSubscriber,
    aocDetails: state.fundialPage.aocDetails,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(notSubscriber);
